"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RangeField = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var Field_1 = require("../Field/Field");
require("./RangeField.css");
var RangeField = function (_a) {
    var _b = _a.rangeLimitMin, rangeLimitMin = _b === void 0 ? 0 : _b, _c = _a.rangeLimitMax, rangeLimitMax = _c === void 0 ? 100 : _c, _d = _a.value, value = _d === void 0 ? [] : _d, _e = _a.minLabel, minLabel = _e === void 0 ? 'MIN' : _e, _f = _a.maxLabel, maxLabel = _f === void 0 ? 'MAX' : _f, className = _a.className, minProps = _a.minProps, maxProps = _a.maxProps, onChange = _a.onChange;
    var min = value[0], max = value[1];
    function handleMinChange(evt) {
        var newValue = evt.target.value;
        onChange([newValue, String(max)], evt);
    }
    function handleMaxChange(evt) {
        var newValue = evt.target.value;
        onChange([String(min), newValue], evt);
    }
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('ui min-max-field', className) },
        react_1.default.createElement(Field_1.Field, __assign({}, minProps, { label: minLabel, kind: "full", fitContent: true, type: "number", value: min, min: rangeLimitMin, max: rangeLimitMax, onChange: handleMinChange })),
        react_1.default.createElement(Field_1.Field, __assign({}, maxProps, { label: maxLabel, kind: "full", fitContent: true, type: "number", value: max, min: rangeLimitMin, max: rangeLimitMax, onChange: handleMaxChange }))));
};
exports.RangeField = RangeField;
